import $ from 'jquery';

$(function () {

    var $body = $('body');
    var $floatingISI = $('.floating-isi');
    var $isi = $('aside.isi');
    var $isiHeader = $('.isi-header');
    var $isiToggle = $('.isi-arrow');
    var $window = $(window);

    var isiHide = false;
    var isISIOpen = false;

    $body.on('click', checkBodyClickForISI);
    $isiHeader.on('click touchend', scrollToISI);
    $isiToggle.on('click touchend', expandFloatingISI);
    $window.on('load', checkScroll);
    $window.on('scroll', checkScroll);

    ////

    function checkBodyClickForISI(event) {
        var $target = $(event.target);

        var $parent = $target.closest('.floating-isi');

        if (isISIOpen && !$parent.length) {
            expandFloatingISI(event);
        }
    }

    function checkScroll() {
        if ($floatingISI[0]) {
            var footerHeight = $('footer').height();
            var top_of_object = $isi.offset().top;
            var bottom_of_object = $isi.offset().top + $isi.outerHeight() + footerHeight;
            var top_of_window = $window.scrollTop();
            var bottom_of_window = $window.scrollTop() + $window.height();
            var sticky_isi_offset = 130;

            if (top_of_window <= bottom_of_object && bottom_of_window >= top_of_object + sticky_isi_offset) {
                if (!isiHide) {
                    isiHide = true;

                    $floatingISI.fadeOut(250);
                }
                if ($floatingISI.hasClass('fixed')) {
                    $floatingISI.removeClass('fixed');

                    $floatingISI.fadeOut(250);
                }
            } else {
                if (!$floatingISI.hasClass('fixed')) {
                    $floatingISI.addClass('fixed');

                    $floatingISI.fadeIn(250);
                }
            }
        }
    }

    function expandFloatingISI(event) {
        event.preventDefault();
        $floatingISI.attr('aria-expanded', (i, attr) => attr === 'true' ? 'false' : 'true');
        isISIOpen = $floatingISI.attr('aria-expanded') === 'true';
    }

    function scrollToISI() {
        var scrollTop = $isi.offset().top;

        $('html, body').animate({ scrollTop }, 'fast');
    }

});
